module.exports = __webpack_public_path__ + "img/d6b7db4.jpg";